// 統計情報を遅延読み込みするAlpine.jsコンポーネント
document.addEventListener('alpine:init', () => {
  const loadingTemplate = `
    <div class="flex flex-col justify-center items-center py-8 space-y-3">
      <svg class="animate-spin h-8 w-8 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
      <div class="text-gray-500 text-sm">統計を計算中<span class="loading-dots"></span></div>
    </div>
  `

  const errorTemplate = '<div class="text-red-500 py-8 text-center">統計の読み込みに失敗しました</div>'

  const createStatsLoader = (componentName) => {
    return (url) => ({
      content: loadingTemplate,

      async load() {
        console.log(`[${componentName}] Loading from:`, url)

        try {
          const response = await fetch(url, {
            headers: {
              'Accept': 'text/html',
              'X-Requested-With': 'XMLHttpRequest'
            }
          })

          console.log(`[${componentName}] Response status:`, response.status)

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
          }

          const html = await response.text()
          console.log(`[${componentName}] Received HTML length:`, html.length)

          this.content = html
          console.log(`[${componentName}] Content updated`)
        } catch (error) {
          console.error(`[${componentName}] Error:`, error)
          this.content = errorTemplate
        }
      }
    })
  }


  Alpine.data('progressStats', createStatsLoader('ProgressStats'))
  Alpine.data('clickStats', createStatsLoader('ClickStats'))
})
